import { CloudImage, Container, Link, Text } from "@fluidattacks/design";
import type { CellContext } from "@tanstack/react-table";
import * as React from "react";
import { useParams } from "react-router-dom";
import { useTheme } from "styled-components";

import type { TPackage } from "../../../hooks";

interface IDependencyColumnProps {
  readonly details: TPackage;
}

const DependencyColumn: React.FC<IDependencyColumnProps> = ({
  details,
}): React.JSX.Element => {
  const { groupName, organizationName } = useParams() as Record<string, string>;
  const baseUrl = `/orgs/${organizationName}/groups/${groupName}/inventory/packages`;
  const theme = useTheme();

  const packageId = encodeURIComponent(`${details.name}@${details.version}`);

  return (
    <Container alignItems={"center"} display={"flex"} gap={0.5}>
      <CloudImage
        height={24}
        publicId={`integrates/supply-chain/logo-${details.platform}`}
        width={24}
      />
      {(details.vulnerable ?? false) ? (
        <Link href={`${baseUrl}/roots/${details.root.id}/${packageId}`}>
          {details.name}
        </Link>
      ) : (
        <Text color={theme.palette.gray["800"]} size={"md"}>
          {details.name}
        </Text>
      )}
    </Container>
  );
};

const formatDependencyColumn = (
  cell: CellContext<TPackage, unknown>,
): React.JSX.Element => {
  const details = cell.row.original;

  return <DependencyColumn details={details} />;
};

export { formatDependencyColumn };
